import Config from "./application/Config";
import AppRouter from "./AppRouter";

class Application {
    private static instance: Application;
    private readonly config: Config;
    protected env: any;

    protected _user: any;


    protected _token: any;
    protected _cognito_user: any;

    public setToken(tok:any) {
        this._token=tok;
    }

    public setCognitoUser(user: any) {
        this._cognito_user = user;
    }

    public getCognitoUser(): any {
        return this._cognito_user;
    }


    public getToken() {
        return this._token;
    }

    private constructor(env = null) {
        if (env !== null) {
            this.env = env;
        }
        this._user = undefined;
        this.config = Config.getInstance(env);
    }

    public runOverlay (duration: number = 4000) {
        const overlay = document.getElementById("fade-overlay");
        if (overlay) {
            overlay.classList.add("opacity-100");
            overlay.classList.remove("opacity-0", "pointer-events-none");

            setTimeout(() => {
                overlay.classList.add("opacity-0");
                overlay.classList.remove("opacity-100");
            }, duration);
        }
    };

    public setUser(user: any) {

        let cfg = Config.getInstance();
        let isPublic = cfg.isCurrentPublicUrl();

        if(isPublic) {
            if(user) {
               let rtr=  AppRouter.getInstance();
               rtr.redirectToAppIfNeeded(location.href);

              // alert("redir there");
            }
        }

        this._user = user;
    }

    public isAuth(): boolean {
        if (this._user !== undefined) {
            return true;
        }
        return false;
    }


    public hasCompany():boolean {
        if(!this.getUser()) {
            return  false;
        }
        return this.getUser().companyId;
    }

    public getUser(): any {
        return this._user;
    }

    public static getInstance(env: any = null): Application {
        if (!Application.instance) {
            Application.instance = new Application(env);
        }
        return Application.instance;
    }

    public static getConfig(): Config {
        return Application.getInstance().getConfig();
    }

    public getConfig(): Config {
        return this.config;
    }
}

export { Application as Applicationx };
export default Application;